<section class="banner">
  <app-profilebanner [is_my_profile]="is_myProfile"></app-profilebanner>
  <div class="profile-header-menu wpee-container">
    <div class="profile-menu-wrapper d-flex space-bet" *ngIf="!loader">
      <div class="ham-icon" [ngClass]="{'is-triggred': is_show_menu_tab}" (click)="is_show_menu_tab=!is_show_menu_tab">
        <span></span>
      </div>
      <ul class="profile-menu-tab" [ngClass]="{ 'is-open': is_show_menu_tab }">
        <li
          class="profile-menu-tab-list"
          [ngClass]="{ active: activeTab === 'Profile' }"
        >
          <a (click)="tabChange('Profile')">Profile</a>
        </li>
        <li
          class="profile-menu-tab-list"
          [ngClass]="{ active: activeTab === 'Media' }"
        >
          <a (click)="tabChange('Media')">Media</a>
        </li>
        <li
          class="profile-menu-tab-list"
          [ngClass]="{ active: activeTab === 'Friends' }"
        >
          <a (click)="tabChange('Friends')">Friends</a>
        </li>
      </ul>
      <div class="profile-notification-blocks">
        <div class="wpee-notification-block-wrap">
          <ul class="wpee-notification-links different-user">
            <li>
              <a (click)="addToFavorite()" title="Add to Favorites" data-nonce="8657e596c1" data-fav-uid="1835"
                class="wpee-add-fav-btn">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                  <path
                    d="M225.8 468.2l-2.5-2.3L48.1 303.2C17.4 274.7 0 234.7 0 192.8l0-3.3c0-70.4 50-130.8 119.2-144C158.6 37.9 198.9 47 231 69.6c9 6.4 17.4 13.8 25 22.3c4.2-4.8 8.7-9.2 13.5-13.3c3.7-3.2 7.5-6.2 11.5-9c0 0 0 0 0 0C313.1 47 353.4 37.9 392.8 45.4C462 58.6 512 119.1 512 189.5l0 3.3c0 41.9-17.4 81.9-48.1 110.4L288.7 465.9l-2.5 2.3c-8.2 7.6-19 11.9-30.2 11.9s-22-4.2-30.2-11.9zM239.1 145c-.4-.3-.7-.7-1-1.1l-17.8-20-.1-.1s0 0 0 0c-23.1-25.9-58-37.7-92-31.2C81.6 101.5 48 142.1 48 189.5l0 3.3c0 28.5 11.9 55.8 32.8 75.2L256 430.7 431.2 268c20.9-19.4 32.8-46.7 32.8-75.2l0-3.3c0-47.3-33.6-88-80.1-96.9c-34-6.5-69 5.4-92 31.2c0 0 0 0-.1 .1s0 0-.1 .1l-17.8 20c-.3 .4-.7 .7-1 1.1c-4.5 4.5-10.6 7-16.9 7s-12.4-2.5-16.9-7z"
                  />
                </svg>
              </a>
            </li>
            <li>
              <a class="wpee-wink-list" (click)="sendMessge()">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                  <path
                    d="M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm177.6 62.1C192.8 334.5 218.8 352 256 352s63.2-17.5 78.4-33.9c9-9.7 24.2-10.4 33.9-1.4s10.4 24.2 1.4 33.9c-22 23.8-60 49.4-113.6 49.4s-91.7-25.5-113.6-49.4c-9-9.7-8.4-24.9 1.4-33.9s24.9-8.4 33.9 1.4zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
                  />
                </svg>
              </a>
             
            </li>
            <li>
              <a (click)="openMessage()">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                  <path
                    d="M64 112c-8.8 0-16 7.2-16 16l0 22.1L220.5 291.7c20.7 17 50.4 17 71.1 0L464 150.1l0-22.1c0-8.8-7.2-16-16-16L64 112zM48 212.2L48 384c0 8.8 7.2 16 16 16l384 0c8.8 0 16-7.2 16-16l0-171.8L322 328.8c-38.4 31.5-93.7 31.5-132 0L48 212.2zM0 128C0 92.7 28.7 64 64 64l384 0c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64L64 448c-35.3 0-64-28.7-64-64L0 128z"
                  />
                </svg>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div [ngClass]="{ 'shine': loader }">
    </div>
  </div>
</section>
<section class="tabs">
  <div class="wpee-container d-flex">
    <div class="profile_tab tab" *ngIf="activeTab == 'Profile'">
      <app-profile-tab></app-profile-tab>
    </div>
    <div class="media_tab tab" *ngIf="activeTab == 'Media'">
      <app-view-photos></app-view-photos>
    </div>
    <div class="friends_tab tab" *ngIf="activeTab == 'Friends'">
      <app-friends-tab></app-friends-tab>
    </div>
    <div
      class="conditional_componant edit-profile"
      *ngIf="activeTab == 'View-Details'"
    >
      <app-view-details></app-view-details>
    </div>
    <div class="sug_user">
      <app-suggestion-user></app-suggestion-user>
      <app-online-member></app-online-member>
    </div>
  </div>
</section>
